import React from 'react'
import OurPhilosophySection from '../../sections/OurPhilosophySection'
import { TimeLineItemProps } from '../../organisms/Timeline/types'
import { OurPhilosophySliceProps } from './types'

const OurPhilosophySlice: React.FC<OurPhilosophySliceProps> = ({ slice }) => {
  const { primary, items = [] } = slice
  const { id, op_title, op_is_main_heading, op_description } = primary || {}

  const data: TimeLineItemProps[] = items.map((item, index) => {
    const { op_item_title, op_item_description, op_item_image } = item || {}

    return {
      key: `timeline-item-${index}`,
      image: {
        publicURL: op_item_image?.url,
        childImageSharp: op_item_image && {
          gatsbyImageData: op_item_image.gatsbyImageData
        },
        width: op_item_image?.dimensions?.width,
        height: op_item_image?.dimensions?.height,
        alt: op_item_image?.alt
      },
      title: op_item_title?.text || '',
      content: op_item_description?.html || ''
    }
  })

  return (
    <OurPhilosophySection
      id={id || slice.id}
      heading={op_title?.text}
      isMainHeading={op_is_main_heading}
      description={op_description?.html}
      headingPadding={['60px', '', '78px']}
      inner="inners.primary"
      paddingTop={['38px', '', '90px']}
      paddingBottom={['30px', '', '50px']}
      data={data}
    />
  )
}

export default OurPhilosophySlice
